import styled from "styled-components";

import { grey } from "@mui/material/colors";

export const CheckoutContainer = styled.div`
  /* border: 1px solid red; */
`;

export const CheckoutCartItems = styled.div`
  border-right: 1px solid ${grey[400]};
`;
